"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessInstanceSortableColumns = void 0;
var ProcessInstanceSortableColumns;
(function (ProcessInstanceSortableColumns) {
    ProcessInstanceSortableColumns["correlationId"] = "correlationId";
    ProcessInstanceSortableColumns["processInstanceId"] = "processInstanceId";
    ProcessInstanceSortableColumns["processDefinitionId"] = "processDefinitionId";
    ProcessInstanceSortableColumns["processModelId"] = "processModelId";
    ProcessInstanceSortableColumns["processModelName"] = "processModelName";
    ProcessInstanceSortableColumns["processModelHash"] = "processModelHash";
    ProcessInstanceSortableColumns["ownerId"] = "ownerId";
    ProcessInstanceSortableColumns["startedByRootAccessToken"] = "startedByRootAccessToken";
    ProcessInstanceSortableColumns["state"] = "state";
    ProcessInstanceSortableColumns["error"] = "error";
    ProcessInstanceSortableColumns["parentProcessInstanceId"] = "parentProcessInstanceId";
    ProcessInstanceSortableColumns["finishedAt"] = "finishedAt";
    ProcessInstanceSortableColumns["terminatedByUserId"] = "terminatedByUserId";
    ProcessInstanceSortableColumns["createdAt"] = "createdAt";
    ProcessInstanceSortableColumns["updatedAt"] = "updatedAt";
    ProcessInstanceSortableColumns["durationInMilliseconds"] = "durationInMilliseconds";
    ProcessInstanceSortableColumns["startToken"] = "startToken";
    ProcessInstanceSortableColumns["startEventId"] = "startEventId";
    ProcessInstanceSortableColumns["startEventType"] = "startEventType";
    ProcessInstanceSortableColumns["endToken"] = "endToken";
    ProcessInstanceSortableColumns["endEventId"] = "endEventId";
    ProcessInstanceSortableColumns["endEventType"] = "endEventType";
    ProcessInstanceSortableColumns["correlationMetadata"] = "correlationMetadata";
    ProcessInstanceSortableColumns["processInstanceMetadata"] = "processInstanceMetadata";
})(ProcessInstanceSortableColumns = exports.ProcessInstanceSortableColumns || (exports.ProcessInstanceSortableColumns = {}));
//# sourceMappingURL=ProcessInstanceQuery.js.map